export function removeNonNumericCharacters(code: string) {
  return code.replace(/\D/g, '');
}
